var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { offerList as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, LinearProgress, FormControlLabel, Checkbox, } from '@mui/material';
import { useNotify } from '../../../hooks/notificationHook';
import useDirectlyUpdatableTextField from '../../../hooks/hoc/useDirectlyUpdatableTextField';
import TextField from '../../atoms/TextFieldNew';
var StockDistributionLabel = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    font-size: 12px;\n    padding-left: 10px;\n  }\n"], ["\n  && {\n    font-size: 12px;\n    padding-left: 10px;\n  }\n"])));
var LotVisibleLabel = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    font-size: 12px;\n    padding-left: 10px;\n    padding-top: 20px;\n  }\n"], ["\n  && {\n    font-size: 12px;\n    padding-left: 10px;\n    padding-top: 20px;\n  }\n"])));
var StyledTextField = styled(TextField)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  .MuiButtonBase-root {\n    padding: 4px 10px;\n    font-size: 0.8125rem;\n  }\n"], ["\n  .MuiButtonBase-root {\n    padding: 4px 10px;\n    font-size: 0.8125rem;\n  }\n"])));
var SampleOrderStocks = function (_a) {
    var offer = _a.offer, isOfferListActive = _a.isOfferListActive;
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var _c = React.useState([]), sampleOrderStocks = _c[0], setSampleOrderStocks = _c[1];
    var _d = React.useState([]), editedSampleOrderStocks = _d[0], setEditedSampleOrderStocks = _d[1];
    var t = useTranslation().t;
    var notify = useNotify();
    var getApi = useRequest(api.getSampleOrderStocks);
    var updateApi = useRequest(api.updateSampleOrderStock);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getApi({
                                offer_list_id: offer.offerList.id,
                                offer_id: offer.id,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response || canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        setSampleOrderStocks(response);
                        setEditedSampleOrderStocks(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [getApi, offer.id, offer.offerList.id]);
    var previousTotalQuantity = React.useMemo(function () { return calcTotalQuantity(sampleOrderStocks); }, [sampleOrderStocks]);
    var currentTotalQuantity = React.useMemo(function () { return calcTotalQuantity(editedSampleOrderStocks); }, [editedSampleOrderStocks]);
    var updateRequest = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, updateApi(data)];
                case 1:
                    response = _a.sent();
                    if (!response)
                        throw Error('response error');
                    notify('success', [t('messages.updateSuccess')]);
                    nextData = sampleOrderStocks.map(function (sampleOrderStock) {
                        return sampleOrderStock.id === response.id ? response : sampleOrderStock;
                    });
                    setSampleOrderStocks(nextData);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [updateApi, sampleOrderStocks, notify, t]);
    var updateStock = React.useCallback(function (id, value) {
        var quantityDelta = calcQuantityDelta({
            sampleOrderStockId: id,
            sampleOrderStocks: sampleOrderStocks,
            newQuantity: parseInt("".concat(value)),
        });
        if (quantityDelta === 0)
            return;
        var data = {
            offer_list_id: offer.offerList.id,
            offer_id: offer.id,
            id: id,
            sample_order_stock: {
                quantity_delta: quantityDelta,
            },
        };
        updateRequest(data);
    }, [offer.id, offer.offerList.id, updateRequest, sampleOrderStocks]);
    var handleCheckboxChange = React.useCallback(function (event, checked, id) {
        var _a;
        var name = event.target.name;
        var data = {
            offer_list_id: offer.offerList.id,
            offer_id: offer.id,
            id: id,
            sample_order_stock: (_a = {},
                _a[name] = checked,
                _a),
        };
        updateRequest(data);
    }, [offer.offerList.id, offer.id, updateRequest]);
    var DirectUpdatableTextField = useDirectlyUpdatableTextField(StyledTextField);
    var sampleOrderStockDistributionLabel = React.useMemo(function () {
        var label = t('pages.offerList.sampleOrderStock.quantity');
        return isOfferListActive
            ? label
            : label + "(".concat(currentTotalQuantity, "/").concat(previousTotalQuantity, ")");
    }, [currentTotalQuantity, isOfferListActive, previousTotalQuantity, t]);
    return (React.createElement("div", null,
        loading && React.createElement(LinearProgress, null),
        sampleOrderStocks.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(StockDistributionLabel, null, sampleOrderStockDistributionLabel),
            React.createElement(Grid, { container: true, spacing: 1, justifyContent: "flex-start", alignItems: "center" }, sampleOrderStocks.map(function (sampleOrderStock) { return (React.createElement(Grid, { item: true, xs: 1, key: sampleOrderStock.id },
                React.createElement(DirectUpdatableTextField, { type: "number", margin: "normal", size: "small", label: sampleOrderStock.office.name, name: "quantity_delta", value: sampleOrderStock.remainingQuantity.toString(), onUpdate: function (value) { return updateStock(sampleOrderStock.id, value); }, onChange: function (value) {
                        var parsedValue = parseInt(value);
                        setEditedSampleOrderStocks(editedSampleOrderStocks.map(function (stock) {
                            if (stock.id !== sampleOrderStock.id) {
                                return stock;
                            }
                            return __assign(__assign({}, stock), { remainingQuantity: isNaN(parsedValue)
                                    ? 0
                                    : parsedValue });
                        }));
                    }, transformValue: function (value) {
                        if (parseInt(value) < 0) {
                            return '0';
                        }
                        return value;
                    } }))); })),
            React.createElement(LotVisibleLabel, null, t('pages.offerList.sampleOrderStock.lotVisibleLabel')),
            React.createElement(Grid, { container: true, spacing: 1, justifyContent: "flex-start", alignItems: "center" }, sampleOrderStocks.map(function (sampleOrderStock) { return (React.createElement(Grid, { item: true, xs: 1, key: sampleOrderStock.id },
                React.createElement(FormControlLabel, { name: "is_visible", control: React.createElement(Checkbox, { color: "primary" }), label: "".concat(sampleOrderStock.office.name, ": ").concat(sampleOrderStock.isVisible
                        ? t('pages.offerList.sampleOrderStock.show')
                        : t('pages.offerList.sampleOrderStock.hide')), labelPlacement: "end", checked: sampleOrderStock.isVisible, onChange: function (event, checked) {
                        return handleCheckboxChange(event, checked, sampleOrderStock.id);
                    } }))); }))))));
};
var calcTotalQuantity = function (sampleOrderStocks) {
    return sampleOrderStocks
        .map(function (stock) { return stock.remainingQuantity; })
        .reduce(function (sum, current) { return sum + current; }, 0);
};
var calcQuantityDelta = function (_a) {
    var sampleOrderStockId = _a.sampleOrderStockId, newQuantity = _a.newQuantity, sampleOrderStocks = _a.sampleOrderStocks;
    var sampleOrderStock = sampleOrderStocks.find(function (stock) { return stock.id === sampleOrderStockId; });
    return newQuantity - sampleOrderStock.remainingQuantity;
};
export default SampleOrderStocks;
var templateObject_1, templateObject_2, templateObject_3;
